export const RECENT_SEARCH_RESULTS_KEY = 'recentSearchResults'
export const MAX_RECENT_SEARCH_RESULTS = 3
